
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_615_12475)"}},[_c('path',{attrs:{"d":"M16.465 1.868l1.215 4.261a1.719 1.719 0 01-1.18 2.124L12.237 9.47a1.719 1.719 0 11-.943-3.305l.12-.035a6.162 6.162 0 00-6.258 2.502A6.16 6.16 0 006.668 17.2a6.16 6.16 0 008.57-1.511 6.124 6.124 0 001.04-4.467 1.72 1.72 0 012.715-1.649 1.719 1.719 0 01.683 1.124 9.58 9.58 0 11-6.447-7.64l-.07-.246A1.72 1.72 0 0115.647.837a1.719 1.719 0 01.817 1.03z","fill":"#ABAFB5"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_615_12475"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h22v22H0z"}})])])])
          )
        }
      }
    